import script from "./Error404.vue?vue&type=script&lang=ts&setup=true"
export * from "./Error404.vue?vue&type=script&lang=ts&setup=true"

import "./Error404.vue?vue&type=style&index=0&id=32f0d5a6&lang=sass"

const __exports__ = script;

export default __exports__